<div class="flex justify-center items-center w-full h-full">
  <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</div>
